export default "__VITE_ASSET__DazKMk7w__"